/* eslint-disable react/prop-types */
/* eslint-disable camelcase */
/* eslint-disable no-unused-vars */
/* eslint-disable react/function-component-definition */
/* eslint-disable spaced-comment */
/* eslint-disable no-extra-boolean-cast */
import React from 'react';
import { Page, Text, View, Document, StyleSheet, Image, Font } from '@react-pdf/renderer';
import moment from 'moment';

import BG_IMAGE from './cert_bg.png';
import QRCODE from './qrcode.jpg';
import { themeColor } from '../../../config/theme/themeVariables';

Font.register({
  family: 'MyFont_BOLD',
  fontWeight: 'bold',
  src: require('../../../static/fonts/Halagar.otf'),
});

Font.register({
  family: 'TABLE_FONT',
  fontWeight: 'bold',
  src: require('../../../static/fonts/TypewriterPress-Regular.ttf'),
});

Font.register({
  family: 'TABLE_FONT_HEADER',
  fontWeight: 'bold',
  src: require('../../../static/fonts/RobotoCondensed-Black.ttf'),
});

Font.register({
  family: 'TABLE_FONT_CELL',
  fontWeight: 'bold',
  src: require('../../../static/fonts/RobotoCondensed-SemiBold.ttf'),
});

Font.register({
  family: 'YearFont',
  fontWeight: 'bold',
  src: require('../../../static/fonts/temp.ttf'),
});

const styles = StyleSheet.create({
  heading: {
    fontSize: 16,
    fontWeight: 'bold',
    fontFamily: 'MyFont_BOLD',
  },
  yearHeading: {
    fontSize: 28,
    fontWeight: 'bold',
    fontFamily: 'YearFont',
    color: themeColor['error-color'],
  },
  topSeres: {
    fontSize: 14,
    width: 100,
    textAlign: 'center',
    fontFamily: 'YearFont',
    // color: themeColor['warning-hover'],
    color: themeColor.black,
  },
  memberNumber: {
    fontSize: 18,
    fontWeight: 'bold',
    fontFamily: 'YearFont',
    color: themeColor['warning-hover'],
  },
  page: {
    backgroundColor: '#fff',
    fontSize: 12,
    padding: 10,
  },
  table: {
    borderWidth: 1,
    borderColor: '#000',
    fontSize: 10,
    borderStyle: 'dotted',
  },
  tableRow: {
    flexDirection: 'row',
  },
  tableCell: {
    padding: 3,
    borderRightWidth: 1,
    borderBottomWidth: 1,
    borderColor: '#000',
    fontFamily: 'TABLE_FONT_CELL',
    borderStyle: 'dotted',
    fontWeight: 'black',
    fontSize: 10,
  },
  tableCellHeader: {
    padding: 3,
    borderRightWidth: 1,
    borderBottomWidth: 1,
    color: 'black',
    fontFamily: 'TABLE_FONT_HEADER',
    textAlign: 'center',
    borderStyle: 'dotted',
    fontSize: 12,
  },
  courseName: {
    flex: 3, // Most width for Course Name
    textAlign: 'left',
  },
  centerName: {
    flex: 2, // Moderate width for Center Name
    textAlign: 'left',
  },
  startDate: {
    flex: 1, // Minimum width for Start Date
    textAlign: 'center',
  },
  endDate: {
    flex: 1, // Minimum width for End Date
    textAlign: 'center',
  },
  numberOfDays: {
    flex: 1, // Minimum width for Number of Days
    textAlign: 'center',
  },
  serNumber: {
    width: 30,
    // flex: 0, // Minimum width for Number of Days
    textAlign: 'center',
  },
  status: {
    flex: 1, // Minimum width for Status
    textAlign: 'center',
  },
  absolutePosition: {
    position: 'absolute',
    zIndex: 1000,
  },
  qrCode: {
    top: 66,
    left: 85,
    width: 92,
    height: 92,
  },
  seriesPosition: {
    top: 44,
    right: 65,
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    width: '100%',
  },
  labelContainer: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    paddingHorizontal: 10,
  },
  labelText: {
    color: 'gray',
    fontSize: 10,
    fontFamily: 'YearFont',
  },
  underline: {
    flex: 1,
    borderBottomWidth: 1,
    borderBottomColor: 'black',
    marginLeft: 5,
  },
  underlinedText: {
    fontSize: 14,
    fontWeight: 'bold',
    textAlign: 'left',
    fontFamily: 'MyFont_BOLD',
  },
});

const dummyData = [
  {
    course_name: 'React Basics',
    center_name: 'Training Center 1',
    start_date_time: '2024-01-01',
    end_date_time: '2024-01-15',
    status_str: 'Passed',
    number_of_days: 10,
  },
  {
    course_name: 'Advanced JavaScript',
    center_name: 'Training Center 2',
    start_date_time: '2024-02-01',
    end_date_time: '2024-02-20',
    status_str: 'Passed',
    number_of_days: 15,
  },
  {
    course_name: 'Node.js Essentials',
    center_name: 'Training Center 3',
    start_date_time: '2024-03-01',
    end_date_time: '2024-03-10',
    status_str: 'Passed',
    number_of_days: 11,
  },
  {
    course_name: 'React Basics',
    center_name: 'Training Center 1',
    start_date_time: '2024-01-01',
    end_date_time: '2024-01-15',
    status_str: 'Failed',
    number_of_days: 18,
  },
];

const calculateDaysDifference = (startDate, endDate) => {
  if (!startDate || !endDate) return 'N/A';
  const start = moment(startDate);
  const end = moment(endDate);
  const diff = end.diff(start, 'days') + 1; // Ensure minimum 1 day
  return diff;
};

const formatCNIC = (cnic) => {
  if (!cnic) return ''; // Handle empty CNIC
  cnic = cnic.toString().trim().replace(/\D/g, ''); // Remove non-numeric characters
  if (cnic.length !== 13) return cnic; // Ensure it's exactly 13 digits
  return `${cnic.slice(0, 5)}-${cnic.slice(5, 12)}-${cnic.slice(12)}`;
};


const MyDocument = ({
  srNo = "000000",
  apsaaNo = "000000",
  printedOn = "Jan 01 2024",
  qrImage = QRCODE,
  sigPrincipal,
  empName = "TEST NAME",
  empFatherName = "TEST FATHER NAME",
  empCNIC = "00000-0000000-0",
  companyName = "Test Company",
  coursesData = dummyData
}) => {
  const pageSize = 'A4';
  // const pageSize = { width: 11.4 * 72, height: 8.268 * 72 }; // Convert inches to points

  return (
    <Document>
      <Page size={pageSize} orientation="landscape" style={styles.page}>
        <Image src={qrImage} style={[styles.absolutePosition, styles.qrCode, { objectFit: 'cover' }]} />
        {/* 44, 67, 90 */}
        <View style={[styles.absolutePosition, styles.seriesPosition, { top: 59 }]}>
          <Text style={styles.topSeres}>{srNo}</Text>
        </View>
        <View style={[styles.absolutePosition, styles.seriesPosition, { top: 81 }]}>
          <Text style={styles.topSeres}>{apsaaNo}</Text>
        </View>
        <View style={[styles.absolutePosition, styles.seriesPosition, { top: 102 }]}>
          <Text style={styles.topSeres}>{printedOn}</Text>
        </View>

        <View style={[styles.absolutePosition, { top: 253, left: 54, right: 54 }]}>
          <View style={styles.row}>
            <View style={styles.labelContainer}>
              <Text style={styles.labelText}>Mr.</Text>
              <View style={styles.underline}>
                <Text style={styles.underlinedText}>{empName}</Text>
              </View>
            </View>
            <View style={styles.labelContainer}>
              <Text style={styles.labelText}>S/O</Text>
              <View style={styles.underline}>
                <Text style={styles.underlinedText}>{empFatherName}</Text>
              </View>
            </View>
            <View style={styles.labelContainer}>
              <Text style={styles.labelText}>CNIC</Text>
              <View style={styles.underline}>
                <Text style={styles.underlinedText}>{formatCNIC(empCNIC)}</Text>
              </View>
            </View>
          </View>

          <View style={[styles.row, { marginTop: 10 }]}>
            <View style={styles.labelContainer}>
              <Text style={styles.labelText}>Company Name:</Text>
              <View style={styles.underline}>
                <Text style={styles.underlinedText}>{companyName}</Text>
              </View>
            </View>
          </View>
        </View>

        <View style={[styles.table, styles.absolutePosition, { top: 305, left: 65, right: 65 }]}>
          <View style={styles.tableRow}>
            <Text style={[styles.tableCellHeader, styles.serNumber]}>S#</Text>
            <Text style={[styles.tableCellHeader, styles.courseName]}>Course Name</Text>
            <Text style={[styles.tableCellHeader, styles.centerName]}>Center Name</Text>
            {/* <Text style={[styles.tableCellHeader, styles.startDate]}>Start Date</Text>
            <Text style={[styles.tableCellHeader, styles.endDate]}>End Date</Text> */}
            <Text style={[styles.tableCellHeader, styles.numberOfDays]}>Duration (Days)</Text>
            <Text style={[styles.tableCellHeader, styles.status]}>Status</Text>
          </View>

          {coursesData.map((row, index) => (
            <View style={styles.tableRow} key={index}>
              <Text style={[styles.tableCell, styles.serNumber]}>{(Number(index) + 1)}</Text>
              <Text style={[styles.tableCell, styles.courseName]}>{row.course_name}</Text>
              <Text style={[styles.tableCell, styles.centerName]}>{row.center_name}</Text>

              {/* <Text style={[styles.tableCell, styles.startDate]}>{row.start_date_time}</Text>
              <Text style={[styles.tableCell, styles.endDate]}>{row.end_date_time}</Text> */}
              <Text style={[styles.tableCell, styles.numberOfDays]}>
                {row.number_of_days ? row.number_of_days : 'N/A'}
              </Text>

              <Text
                style={{
                  ...styles.tableCell,
                  ...styles.status,
                  color: row.status_str === 'Passed' ? themeColor['success-color'] : themeColor['error-color'],
                }}
              >
                {row.status_str}
              </Text>
            </View>
          ))}
        </View>

        <View style={[styles.absolutePosition, { top: 415, right: 42 }]}>
          <Image src={sigPrincipal} style={{ width: 200, height: 100 }} />
        </View>
        <Image src={BG_IMAGE} style={[styles.absolutePosition, { top: 1, left: 1, right: 1, bottom: 1, zIndex: 1003 }]} />
      </Page>
    </Document>
  );
};

export default MyDocument;
